export enum CaseViewType {
  Kanban = "kanban",
  Table = "table",
}
